import type { UserDataResource } from "../../user-data";

export enum UserTypeEnum {
  Regular = "regular",
  Developer = "developer",
  Owner = "owner",
}

export interface UserResource {
  id: string;
  gid: string;
  name: string;
  login: string;
  created_at: string;
  updated_at: string;
  is_superuser: boolean;
  user_type: UserTypeEnum;
  settings: string | null;
  user_data?: UserDataResource[];
  permissions?: string;
  is_impersonated: boolean;
  is_impersonator: boolean;
  can_be_impersonated: boolean;
  can_impersonate?: boolean;
}

export type UpdateUserRequestBody = {
  name: string;
  login: string; // email
  password: string;
};

export type StoreUserRequestBody = {
  name: string;
  login: string; // email
  password: string;
};
